export const isFromPatientMessage = (message, isPatientNumber) =>
  message?.direction !== "system" && isPatientNumber(message?.from);

export const isNewestUnreadMessage = (
  message,
  messageList,
  isPatientNumber,
  unreadCount,
) => {
  if (unreadCount <= 0 || !isFromPatientMessage(message, isPatientNumber)) {
    return false;
  }

  const patientMessages = (messageList || []).filter((item) =>
    isFromPatientMessage(item, isPatientNumber),
  );
  const messageIndex = patientMessages.indexOf(message);
  return messageIndex !== -1 && messageIndex >= patientMessages.length - unreadCount;
};

export const shouldReviewFetchedMessage = (message, matchesPatientPhone) => {
  if (message?.direction === "system") return false;
  return message?.direction === "inbound" || matchesPatientPhone(message?.from);
};

export const shouldReviewCachedMessage = (message, matchesPatientPhone) =>
  message?.direction !== "system" && matchesPatientPhone(message?.from);
